module.exports = __webpack_public_path__ + "img/workflow-dashboard.7eb40972.svg";